import React from 'react'
import { FooterUnderData, FooterData } from './FooterData'
import FooterMenu, { Footer } from "../Footers/Footer"
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { ImageComp } from '../ImageCompo/ImageComp'
import "./FooterComp.css"
import { ParagraphComp } from '../ParagraphComp/ParagraphComp'
import HoverImage from '../HeaderSec/hoverImage'
import { hoverImages } from '../HeaderSec/HeaderSecDatas'
const FooterComp = (props, { theme }) => {
    return (
        <>
            <Footer className={`${props.className ? ` ${props.className}` : ""}`} theme={props.theme}>
                <Container className='ml-0 mr-0 w-[100%] max-w-[100%] no-print'>
                    <div className="py-[-7%] lg:py-[-8%] sm:py-[50px]">
                        <Row md={4} sm={3} className="justify-between md:justify-center">
                            <Col className="m-0 md:text-center sm:text-start" lg={{ offSet: 0, span: 3, order: 0 }} sm={{ span: 6, order: 5, offSet: 2 }} md={{ span: 4, offset: 0, order: 5 }} xs={{ span: 12, order: 5, offSet: 2 }}>
                                <Link to="/" className="text-slateblue mb-[15px] mt-[5px] inline-block">
                                    {props.logo && <img loading="lazy" src={props.logo} alt="logo" width="111" height="36" />}
                                </Link>
                                <div className='flex flex-col justify-between max-sm:h-auto h-full'>


                                    <div className='flex flex-col items-start gap-4'>
                                        <ImageComp source='/Images/logo.png' className='w-[75%] max-w-[100%] object-cover max-h-[100%]' />
                                        <div className='FooterCompIcons flex items-center gap-3 max-md:p-3'>
                                            <div className='flex flex-col'>

                                                <div className="icon">

                                                    {hoverImages.slice(3, 6).map((image, index) => (
                                                        <HoverImage
                                                            key={index}
                                                            defaultSrc={image.defaultSrc}
                                                            hoverSrc={image.hoverSrc}
                                                            alt={image.alt}
                                                            link={image.link}
                                                        />
                                                    ))}

                                                    {hoverImages.slice(0, 3).map((image, index) => (
                                                        <HoverImage
                                                            key={index}
                                                            defaultSrc={image.defaultSrc}
                                                            hoverSrc={image.hoverSrc}
                                                            alt={image.alt}
                                                            link={image.link}
                                                        />
                                                    ))}
                                                </div>
                                                <div className="icon">


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ParagraphComp className={'text-sm text-black text-justify'} text="*Please exercise due care and diligence while responding/ participating/ giving to announcements, campaigns, asks, offers, etc. These are shared as submitted by users and are not vetted by us." />
                                </div>
                            </Col>
                            <FooterMenu data={FooterData.slice(0, 3)} lg={{ span: 3, offSet: 1, order: 0 }} md={{ span: 3, order: 0 }} sm={{ span: 1, offSet: 1, order: 2 }} className="xl:px-[15px] md:mb-[10px] xs:mb-[25px]" titleClass="capitalize" />
                        </Row>
                    </div>
                </Container>
            </Footer>
            <div className={`h-auto ${props?.theme === "light" ? 'bg-[#4472C4]' : 'bg-[#004878]'} gap-4 p-[10px] justify-center flex flex-wrap`}>
                {FooterUnderData.map(ele =>
                    <Link to={ele.path}>
                        <ParagraphComp className={'text-base font-semibold text-white max-sm:text-lg'} text={ele.text} />
                    </Link>
                )}
            </div >
            <div className='h-auto bg-white gap-4 p-[10px] justify-center flex flex-wrap'>
                <ParagraphComp className={'text-sm text-black'} text="GuideStar India is an initiative of Civil Society Information Services India (CSISI), a public charitable trust registered in India with 12A, 80G, FCRA and Darpan registrations. ©2025 CSISI." />
            </div>
        </>
    )
}

export default FooterComp